// @flow

import * as React from "react";

import Image from "../atoms/Image";
import TextButton from "../atoms/TextButton";

import { type ImageType, type LinkType } from "../../types";

type PropsType = {
    alignment: "left" | "right",
    image: ImageType,
    description?: string,
    title: string,
    cta?: LinkType,
};

const ImageText = (props: PropsType): React.Node => {
    // const RootEl = props.cta ? LinkHandler : "div";
    const classes = ["image-text"];

    classes.push(`image-text--${props.alignment}`);

    return (
        <div className={classes.join(" ")}>
            <div className="row">
                <div className="col-xs-12 col-md-5">
                    <div className="image-text__image">
                        <Image
                            image={props.image}
                            size={"large"}
                            alt="test"
                            aspectRatio="3:2"
                        />
                    </div>
                </div>
                <div className="col-xs-12 col-md-7">
                    <h2 className="image-text__title">{props.title}</h2>
                    <p className="image-text__description">
                        {props.description}
                    </p>
                    {props.cta ? (
                        <TextButton
                            className="image-text__cta"
                            to={props.cta.url}
                            target={props.cta.target}
                        >
                            {props.cta.title}
                        </TextButton>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

ImageText.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default ImageText;
